import React from "react";

function PopupButtonBlock({
  block,
  updateBlock,
  removeBlock
}) {

  return (

    <div className="popup-block popup-button-block">

      <h4>🔘 Bloc Bouton</h4>

      <input
        type="text"
        placeholder="Texte du bouton"
        value={block.label || ""}
        onChange={(e) =>
          updateBlock(
            block.id,
            "label",
            e.target.value
          )
        }
      />

      <input
        type="text"
        placeholder="Lien interne ou externe"
        value={block.url || ""}
        onChange={(e) =>
          updateBlock(
            block.id,
            "url",
            e.target.value
          )
        }
      />

      <select
        value={block.target || "_self"}
        onChange={(e) =>
          updateBlock(
            block.id,
            "target",
            e.target.value
          )
        }
      >
        <option value="_self">
          Même page
        </option>

        <option value="_blank">
          Nouvel onglet
        </option>
      </select>

      <div className="button-colors">

        <label>
          Couleur fond
        </label>

        <input
          type="color"
          value={
            block.background ||
            "#ff7b00"
          }
          onChange={(e) =>
            updateBlock(
              block.id,
              "background",
              e.target.value
            )
          }
        />

        <label>
          Couleur texte
        </label>

        <input
          type="color"
          value={
            block.color ||
            "#ffffff"
          }
          onChange={(e) =>
            updateBlock(
              block.id,
              "color",
              e.target.value
            )
          }
        />

      </div>

      <div
        className="button-preview"
      >

        <button
          style={{
            background:
              block.background ||
              "#ff7b00",

            color:
              block.color ||
              "#fff",

            border: "none",

            padding:
              "10px 18px",

            borderRadius:
              "8px",

            cursor:
              "pointer"
          }}
        >

          {
            block.label ||
            "Bouton"
          }

        </button>

      </div>

      <button
        className="remove-block-btn"
        onClick={() =>
          removeBlock(
            block.id
          )
        }
      >
        ❌ Supprimer
      </button>

    </div>

  );

}

export default PopupButtonBlock;